module.exports = __webpack_public_path__ + "assets/img/Structure_item3.e9d0a7c2.png";